export default __webpack_public_path__ + "static/media/expandNew.d8db6481.svg";